module.exports = __webpack_public_path__ + "img/logo-precision.74ca66eb.svg";